import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../dialog';
import { Button } from '../button';

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string | React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  secondaryText?: string;
  additionalButton?: {
    text: string;
    onClick: () => void;
  };
  loading?: boolean;
}

export function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Delete',
  cancelText = 'Cancel',
  secondaryText = 'Deleting',
  additionalButton,
  loading = false
}: ConfirmDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-brand-dark dark:text-foreground">{title}</DialogTitle>
        </DialogHeader>
        <div className="py-3 text-brand-dark dark:text-foreground">{message}</div>
        <div className="flex justify-end gap-2">
          <Button type="button" variant="outline" size="sm" onClick={onClose}>
            {cancelText}
          </Button>
          {additionalButton && (
            <Button type="button" variant="outline" size="sm" onClick={additionalButton.onClick}>
              {additionalButton.text}
            </Button>
          )}
          <Button variant="destructive" size="sm" onClick={onConfirm} disabled={loading}>
            {loading ? secondaryText : confirmText}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
} 